import { cssVars } from '@/app/styles';
import { Charts } from '@/chart/chart';
import { BarChartOptions } from '@/chart/chart-options';
import { DEFAULT_CHART_BASE_TYPE } from '@/chart/components/all-charts-styles';
import { DisplayMinMaxValuePlugin } from '@/chart/plugins/display-min-max-value-plugin';
import { datasetTypes } from '@/constants';
import {
  MultiValueDataBuilder,
  constructDatasets,
} from '@/utils/chart-data-builder';
import { numberWithCommas } from '@/utils/string-utils';

// TODO: Rename this to UnitTypeDataBuilder
export class UnitTypeDataBuilder extends MultiValueDataBuilder {
  constructor(
    data,
    barThickness = 10,
    dataType = 'unitType',
    extractionType = 'percentage'
  ) {
    super(data, dataType, extractionType);
    this.barThickness = barThickness;
  }

  get configurations() {
    return [
      {
        fill: false,
        borderColor: cssVars.color.unitType.unknownAccent,
        backgroundColor: cssVars.color.unitType.unknownAccent,
        pointBackgroundColor: cssVars.color.unitType.unknownAccent,
        pointRadius: 3, // dot radius
        pointHoverRadius: 5, // dot radius on hover
        barThickness: this.barThickness,
      },
      {
        fill: false,
        borderColor: cssVars.color.unitType.selfContainedAccent,
        backgroundColor: cssVars.color.unitType.selfContainedAccent,
        pointBackgroundColor: cssVars.color.unitType.selfContainedAccent,
        pointRadius: 3, // dot radius
        pointHoverRadius: 5, // dot radius on hover
        barThickness: this.barThickness,
      },
      {
        fill: false,
        borderColor: cssVars.color.unitType.partialAccent,
        backgroundColor: cssVars.color.unitType.partialAccent,
        pointBackgroundColor: cssVars.color.rentalType.partialAccent,
        pointRadius: 3, // dot radius
        pointHoverRadius: 5, // dot radius on hover
        borderDash: [8, 5],
        barThickness: this.barThickness,
      },
    ];
  }

  get retrieveDatasets() {
    return constructDatasets(
      this.labels,
      this.data,
      'bar',
      this.configurations
    );
  }
}

// TODO: Rename this to UnitTypeChart
class RentalTypeChart extends Charts {
  static pluginParams = {
    pluginTextColor: cssVars.chartColors.RENTAL_TYPE, // TODO: fix. undefined
    pluginFormatter: numberWithCommas,
    pluginAlignment: 'top',
  };

  static tooltipParams = {
    unit: '%',
  };

  static isStackedBar = true;

  static getParams() {
    return {
      pluginParams: this.pluginParams,
      tooltipParams: this.tooltipParams,
      isStackedBar: this.isStackedBar,
    };
  }

  static getOptions(props) {
    return {
      ...RentalTypeChart.getParams(),
      ...props,
    };
  }

  constructor(props) {
    super({
      DataBuilder: UnitTypeDataBuilder,
      chartProps: props,
      name: datasetTypes.UNIT_TYPE,
      options: new BarChartOptions(RentalTypeChart.getOptions(props))
        .chartOptions,
      baseType: DEFAULT_CHART_BASE_TYPE,
      plugins: [DisplayMinMaxValuePlugin()],
    });
  }
}

const chart = (props) => new RentalTypeChart(props).chart;

export default chart;
